// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var EventType;
(function (EventType) {
    EventType[EventType["None"] = 0] = "None";
    EventType[EventType["Info"] = 1] = "Info";
    EventType[EventType["Exception"] = 2] = "Exception";
    EventType[EventType["Trading"] = 3] = "Trading";
    EventType[EventType["System"] = 4] = "System";
    EventType[EventType["Comment"] = 5] = "Comment";
    EventType[EventType["Updater"] = 6] = "Updater";
    EventType[EventType["Alerts"] = 7] = "Alerts";
})(EventType || (EventType = {}));
export var EventSource;
(function (EventSource) {
    EventSource[EventSource["None"] = 0] = "None";
    EventSource[EventSource["Out"] = 1] = "Out";
    EventSource[EventSource["MarginCall"] = 2] = "MarginCall";
    EventSource[EventSource["Refused"] = 3] = "Refused";
    EventSource[EventSource["In"] = 4] = "In";
})(EventSource || (EventSource = {}));
export var TradingEventType;
(function (TradingEventType) {
    TradingEventType[TradingEventType["Request"] = 0] = "Request";
    TradingEventType[TradingEventType["Create"] = 1] = "Create";
    TradingEventType[TradingEventType["Modify"] = 2] = "Modify";
    TradingEventType[TradingEventType["Fill"] = 3] = "Fill";
    TradingEventType[TradingEventType["MarginCall"] = 4] = "MarginCall";
    TradingEventType[TradingEventType["Remove"] = 5] = "Remove";
    TradingEventType[TradingEventType["Reject"] = 6] = "Reject";
    TradingEventType[TradingEventType["NotTrading"] = 7] = "NotTrading";
})(TradingEventType || (TradingEventType = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["ProductRequestCantProcess"] = 432] = "ProductRequestCantProcess";
    ErrorCodes[ErrorCodes["ProductSubscriptionNoActiveAccounts"] = 436] = "ProductSubscriptionNoActiveAccounts";
    ErrorCodes[ErrorCodes["ProductSubscriptionNotEnoughBalance"] = 437] = "ProductSubscriptionNotEnoughBalance";
    ErrorCodes[ErrorCodes["ProductIsNoLongerRelevantForUse"] = 446] = "ProductIsNoLongerRelevantForUse";
})(ErrorCodes || (ErrorCodes = {}));
